"use client";

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@pex/ui-web";
import Image from "next/image";

const TESTIMONIALS = [
  {
    quote:
      "\u201CProject Exodus has taught me so many amazing things to help myself and I love the online supporters group.\u201D",
    name: "Theresa Van Der Vyfer",
    avatar:
      "/images/testimonials/Beaches___Oceans_14_Palm_tree_on_beach_63ikgp.avif",
  },
  {
    quote:
      "\u201CWhen I came into recovery I was broken and hopeless. I found support and encouragement in a community that did not give up on me. Perseverance is worth it for the freedom I find in recovery and the gifts including restored relationships and new hope.\u201D",
    name: "Natalie Swain",
    avatar:
      "/images/testimonials/Flowers_441_Sir_Harry_Pilkington_rose_5ess3o.webp",
  },
  {
    quote:
      "\u201CI was a broken soul before I heard that I also had a recovery to mend, I have learnt so much from going to recovery group.\u201D",
    name: "Tarrin Merryweather",
    avatar:
      "/images/testimonials/Beaches___Oceans_74_Flooded_marshes_x1kco0.webp",
  },
  {
    quote:
      "\u201CIt really opened my eyes and it made me face my struggles. I learnt that talking about pornography addiction shouldn\u2019t be taboo anymore.\u201D",
    name: "Thabiso Dlamini",
    avatar: "/images/testimonials/Beaches___Oceans_28_Iceberg_s7pgza.avif",
  },
  {
    quote:
      "\u201CFor me, attending and engaging at the groups and training Project Exodus provides has changed my life. I have grown so, so much. If you are looking for help for yourself or for a loved one spend some time around the groups and invest in the resources that are available to get the help that is needed.\u201D",
    name: "Jarred Koen",
    avatar: "/images/testimonials/Beaches___Oceans_36_Honolulu_sirst5.avif",
  },
  {
    quote:
      "\u201CMy life was chaotic and out of control. My recovery journey has brought me back to God and I now live in serenity.\u201D",
    name: "Silvana Cooper",
    avatar: "/images/testimonials/Beaches___Oceans_6_Lighthouse_wtfqgh.avif",
  },
  {
    quote:
      "\u201CRecovery has saved my sanity, my marriage and my family. My husband and I are a team, enjoying the life God meant for us. We love the culture of recovery and the community of people in it.\u201D",
    name: "Kelly Pretorius",
    avatar: "/images/testimonials/Flowers_445_Centaurea_cyanus_9pgf1f.webp",
  },
  {
    quote:
      "\u201CWhen I came into recovery, it was not what I wanted; however, it was definitely what I needed. Through this journey, I have grown as a person and I have found a supportive, loving tribe who I am so grateful for.\u201D",
    name: "Melissa Morgan-Eaves",
    avatar: "/images/testimonials/Flowers_422_Wild_flowers_98orvw.webp",
  },
  {
    quote:
      "\u201CI had been a member - sometimes an observer, sometimes a participant of other support groups for addiction for a very long time and only when I heard of the Project Exodus Recovery group on a Monday night and have been a committed and active member, I have gone from being sober to being happy, joyous and free.\u201D",
    name: "Nadine Harley",
    avatar:
      "/images/testimonials/Famous_Buildings_509_Great_Wall_of_China_3xuc52.webp",
  },
  {
    quote:
      "\u201CI\u2019ve learnt that recovery is possible for everyone.\u201D",
    name: "Elmah Mabuza",
    avatar: "/images/testimonials/Flowers_429_Rose_bush_zfyi6a.webp",
  },
  {
    quote:
      "\u201CLooking back on my journey on what I have overcome and where I am and currently dealing with, I am able to identify the roots and why I used.\u201D",
    name: "Hannelie Vosloo",
    avatar:
      "/images/testimonials/Countryside_Scenes_217_Snowy_lake_5kids5.webp",
  },
  {
    quote:
      "\u201COpened my heart, ears and eyes to the light still ahead and how it is possible.\u201D",
    name: "Deryl Daniels",
    avatar: "/images/testimonials/Monuments___Art_183_Kelpies_lkg8yr.webp",
  },
] as const;

const STAR_KEYS = ["1", "2", "3", "4", "5"] as const;

function StarRating() {
  return (
    <div aria-label="5 out of 5 stars" className="flex gap-0.5" role="img">
      {STAR_KEYS.map((n) => (
        <svg
          aria-hidden="true"
          className="h-5 w-5 fill-amber-400 text-amber-400"
          key={n}
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
        </svg>
      ))}
    </div>
  );
}

export function RecoveryGroupsTestimonialsCarousel() {
  return (
    <div className="relative">
      {/* Edge fade overlays — pointer-events-none so cards/buttons remain interactive */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute top-0 bottom-16 left-0 z-10 hidden w-32 sm:block"
        style={{
          background:
            "linear-gradient(to right, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.6) 40%, rgba(255,255,255,0) 100%)",
        }}
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute top-0 right-0 bottom-16 z-10 hidden w-32 sm:block"
        style={{
          background:
            "linear-gradient(to left, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.6) 40%, rgba(255,255,255,0) 100%)",
        }}
      />
      <Carousel className="w-full" opts={{ loop: true }}>
        <CarouselContent className="-ml-4">
          {TESTIMONIALS.map((t) => (
            <CarouselItem className="pl-4 md:basis-1/2" key={t.name}>
              <div className="flex h-full flex-col gap-4 rounded-2xl border bg-card p-6 shadow-sm">
                <StarRating />
                <p className="body-base flex-1">{t.quote}</p>
                <div className="flex items-center gap-3">
                  <div className="relative h-9 w-9 shrink-0 overflow-hidden rounded-full">
                    <Image
                      alt=""
                      className="object-cover"
                      fill
                      sizes="36px"
                      src={t.avatar}
                    />
                  </div>
                  <span className="font-semibold text-sm">{t.name}</span>
                </div>
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
        <div className="mt-6 flex items-center gap-2 px-1">
          <CarouselPrevious className="static translate-y-0" />
          <CarouselNext className="static translate-y-0" />
        </div>
      </Carousel>
    </div>
  );
}
